import styled from "styled-components";
import { thirdColor, primaryColor, secondaryColor } from "../../../config";

export const Wrapper = styled.div`
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  overflow-x: hidden;

  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  @-webkit-keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  .login-page {
    display: flex;
    direction: ltr; /* keep flex order predictable; form content sets its own dir */
    flex-direction: ${({ theme }) =>
      theme?.direction === "rtl" ? "row-reverse" : "row"};
    flex-wrap: nowrap;
    height: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    background-color: #ededed;
    position: relative;
    overflow: hidden;
  }

  .login {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-image: linear-gradient(
        135deg,
        transparent 0%,
        transparent 26%,
        ${thirdColor} 26%,
        ${thirdColor} 72%,
        transparent 72%,
        transparent 82%,
        ${primaryColor} 82%,
        ${primaryColor} 100%
      ),
      linear-gradient(
        45deg,
        transparent 0%,
        transparent 4%,
        ${primaryColor} 4%,
        ${primaryColor} 22%,
        ${secondaryColor} 22%,
        ${secondaryColor} 60%,
        transparent 60%,
        transparent 100%
      ),
      linear-gradient(90deg, rgb(255, 255, 255), rgb(255, 255, 255));
    position: relative;
  }

  .login_box {
    max-width: 400px;
    width: 100%;
    background-color: #fff;
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    border: 1px solid #f1f1f4;
    box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
    padding: 2.5rem;
    .text-gray-500 {
      color: #78829d;
      font-size: 0.8125rem;
      line-height: 1.125rem;
      margin-inline-end: 0.375rem;
      text-align: center;
      margin-bottom: 1.3rem;
    }
    .fw-bolder {
      text-align: center;
      margin-bottom: 1rem;
      color: #071437;
      font-size: 1.125rem;
      font-weight: 600;
    }
  }
  .sign-up-link {
    span {
      color: #78829d;
      font-size: 0.8125rem;
      line-height: 1.125rem;
      margin-inline-end: 0.375rem;
    }
    a {
      color: #1b84ff;
      font-size: 0.8125rem;
      text-decoration: inherit;
    }
  }
  .h-100 {
    height: 100%;
  }
  .sign-in {
    max-height: 580px !important;
  }
  .box-l {
    background-color: #ddd;
    position: relative;
    border: 2px solid transparent;
    background: #fff;
    background-clip: padding-box;
    border-radius: 20px !important;
    padding: 40px;
  }
  .box-l::before {
    content: "";
    background: #fff;
    position: absolute;
    z-index: -1;
    border-radius: 20px;
    box-shadow: 0 0 75px #dddddddb;
  }
  .mw-450px {
    max-width: 450px !important;
  }
  .text-center {
    text-align: center;
  }
  .head-title {
    font-weight: bold;
  }
  .head-subtitle {
    font-size: 14px;
    color: #656565;
    font-weight: 500;
    font-family: Inter;
  }
  .h-60px {
    height: 60px !important;
  }
  .h-50px {
    height: 50px !important;
  }

  .ant-input-outlined:focus-within {
    box-shadow: none;
  }
  .ant-input::placeholder {
    color: #b1b1b1;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    padding: 24px 16px 72px;
    margin: 0;
    width: auto;
    min-width: 0;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    background-color: transparent;
    direction: ${({ theme }) => theme?.direction || "ltr"};
  }

  .login-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 450px;
    padding: 15px;
    padding-top: 13px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .login-card-inner {
    width: 100%;
  }

  .login-logo {
    text-align: center;

    img {
      width: 100px;
      max-width: 30vw;
      height: auto;
    }
  }

  .login-form {
    width: 100%;
    padding: 20px;
  }

  .login-form-body {
    padding: 16px;
  }

  .login-heading {
    text-align: center;
    margin-bottom: 20px;

    h1 {
      color: #212529;
      margin-bottom: 8px;
      font-size: 24px;
      font-weight: 500;
    }

    .login-subtitle {
      color: #6c757d;
      font-weight: 500;
      font-size: 16px;
    }
  }

  .signup-form {
    width: 100%;
  }

  .signup-phone-prefix {
    color: #495057;
    font-weight: 500;
    white-space: nowrap;
  }

  .signup-stepper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
    color: #98a2b3;
    font-size: 13px;
    font-weight: 600;
  }

  .signup-step {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }

  .signup-step.is-active {
    color: #073b4c;
  }

  .signup-step-index {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e9edf2;
    color: #98a2b3;
    font-size: 12px;
  }

  .signup-step.is-active .signup-step-index {
    background: #073b4c;
    color: #fff;
  }

  .signup-step-line {
    flex: 1;
    height: 1px;
    background: #e4e7ec;
  }

  .signup-step-line.is-complete {
    background: #073b4c;
  }

  .signup-icon-tile {
    width: 72px;
    height: 72px;
    margin: 4px auto 8px;
    border-radius: 16px;
    background: #f4f6f8;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f5a524;
    font-size: 28px;
  }

  .signup-next-steps {
    background: #f7f8fa;
    border-radius: 12px;
    padding: 14px 16px;
    margin: 4px 0 16px;
    text-align: start;

    h2 {
      margin: 0 0 10px;
      font-size: 11px;
      letter-spacing: 0.06em;
      color: #98a2b3;
      font-weight: 700;
    }

    ol {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 8px;
      counter-reset: signup-step;
    }

    li {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #344054;
      font-size: 14px;
    }

    li::before {
      counter-increment: signup-step;
      content: counter(signup-step);
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #fff4e5;
      color: #f5a524;
      font-size: 11px;
      font-weight: 700;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
    }
  }

  .signup-phone-note {
    margin: 8px 0 0;
    text-align: center;
    color: #98a2b3;
    font-size: 13px;
    line-height: 1.45;
  }

  .signup-resend {
    margin-top: 14px;
    text-align: center;
    color: #6c757d;
    font-size: 14px;

    .ant-btn-link {
      padding: 0;
      height: auto;
      color: #073b4c;
      font-weight: 600;
    }
  }

  .signup-phone-field {
    margin-bottom: 4px;
  }

  .signup-otp {
    margin: 4px 0 16px;

    .ant-otp {
      justify-content: space-between;
    }
  }

  .signup-verified-list {
    background: #f7f8fa;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #344054;
      font-size: 14px;
    }

    > div + div {
      margin-top: 10px;
    }

    .anticon {
      color: #12b76a;
    }
  }

  .ant-otp {
    width: 100%;
    justify-content: space-between;
  }

  .login-footer-links {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    text-align: center;

    span {
      color: #6c757d;
      font-weight: 500;
      font-size: 16px;
    }

    a {
      color: #212529;
      font-weight: 500;
      font-size: 16px;
      text-decoration: none;
    }
  }

  .login-footer-bar {
    position: absolute;
    bottom: 24px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    direction: ltr; /* isolate from form RTL so order stays predictable */
    ${({ theme }) =>
      theme?.direction === "rtl"
        ? `
      left: 50px;
      right: 24px;
      flex-direction: row-reverse;
    `
        : `
      left: 24px;
      right: 50px;
      flex-direction: row;
    `}
  }

  .login-card.phone-validation {
    max-width: 448px;
    padding: 32px;
    border-radius: 16px;
    box-shadow:
      0px 20px 25px -5px rgba(0, 0, 0, 0.06),
      0px 8px 10px -6px rgba(0, 0, 0, 0.06);

    .login-form-body {
      padding: 0;
    }

    .login-logo img {
      width: 98px;
      height: 52px;
      object-fit: contain;
    }

    .signup-stepper {
      gap: 8px;
      margin: 20px 0 0;
      padding: 0;
      color: #083b4c;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
    }

    .signup-step {
      gap: 6px;
    }

    .signup-step-index {
      width: 20px;
      height: 20px;
      background: #083b4c;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      line-height: 15px;
    }

    .signup-step-line,
    .signup-step-line.is-complete {
      height: 1px;
      background: #083b4c;
    }

    .signup-icon-tile {
      width: 80px;
      height: 80px;
      margin: 28px auto 0;
      border-radius: 16px;
      background: #e3e9eb;
      color: #083b4c;
      font-size: 40px;
    }

    .login-heading {
      margin: 20px 0 0;

      h1 {
        margin: 0;
        color: #083b4c;
        font-size: 18px;
        font-weight: 600;
        line-height: 27px;
      }

      .login-subtitle {
        margin-top: 0;
        color: #b3b3b3;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .signup-otp {
      display: flex;
      justify-content: center;
      margin: 28px 0 0;

      .ant-otp {
        width: auto;
        gap: 10px;
        justify-content: center;
      }

      .ant-otp-input,
      .ant-input {
        width: 44px;
        min-width: 44px;
        height: 52px;
        border-radius: 12px;
        border-color: #dde1e7;
        font-size: 18px;
        font-weight: 600;
        color: #083b4c;
      }
    }

    .phone-verify-button {
      margin-top: 20px;
      height: 44px;
      border: none;
      border-radius: 10px;
      background: #083b4c;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.35px;
      box-shadow: none;

      &:hover,
      &:focus {
        background: #083b4c !important;
        color: #fff !important;
      }
    }

    .signup-resend {
      margin: 16px 0 0;

      button {
        border: none;
        background: transparent;
        padding: 0;
        color: #737373;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .signup-phone-note {
      max-width: 320px;
      margin: 20px auto 0;
      color: #b3b3b3;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  .language-switcher {
    position: absolute;
    z-index: 20;
    bottom: 28px;
    color: #fff;
    ${({ theme }) =>
      theme?.direction === "rtl"
        ? "left: 36px; right: auto;"
        : "right: 36px; left: auto;"}

    button {
      color: inherit;
    }

    &.is-muted {
      bottom: 31px;
      color: rgba(255, 255, 255, 0.4);
    }
  }

  .login-copyright {
    flex: 1 1 auto;
    order: 1;
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    text-align: ${({ theme }) =>
      theme?.direction === "rtl" ? "right" : "left"};

    strong {
      font-weight: 700;
      color: #495057;
    }
  }

  .bg-section {
    flex: 0 0 auto;
    align-self: stretch;
    height: 100vh;
    height: 100dvh;
    width: auto;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;

    .bg-image {
      height: 100%;
      width: auto;
      display: block;
      object-fit: contain;
      object-position: ${({ theme }) =>
        theme?.direction === "rtl" ? "left center" : "right center"};
    }
  }

  /* Tablet */
  @media (max-width: 1099px) and (min-width: 769px) {
    .form-section {
      flex: 0 0 100%;
      width: 100%;
      padding: 32px 24px 80px;
    }

    .bg-section {
      display: none;
    }

    .language-switcher {
      color: #495057;
      bottom: 20px;
      ${({ theme }) =>
        theme?.direction === "rtl"
          ? "left: 24px; right: auto;"
          : "right: 24px; left: auto;"}
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    .login-page {
      flex-direction: column;
    }

    .form-section {
      flex: 0 0 100%;
      width: 100%;
      max-width: 100%;
      padding: 16px 12px 80px;
      margin: 0;
      justify-content: flex-start;
      min-height: 100vh;
      min-height: 100dvh;
    }

    .login-card {
      max-width: 100%;
      margin-top: 8px;
      padding: 12px;
      border-radius: 16px;
    }

    .login-form {
      padding: 8px;
    }

    .login-form-body {
      padding: 8px;
    }

    .login-heading {
      margin-bottom: 16px;

      h1 {
        font-size: 20px;
      }

      .login-subtitle {
        font-size: 14px;
      }
    }

    .login-logo img {
      width: 80px;
    }

    .login-footer-links {
      span,
      a {
        font-size: 14px;
      }
    }

    .head-title {
      font-size: 19px;
    }

    .head-subtitle {
      font-size: 12px;
    }

    .bg-section {
      display: none;
    }

    .language-switcher {
      color: #495057;
      bottom: 16px;
      ${({ theme }) =>
        theme?.direction === "rtl"
          ? "left: 16px; right: auto;"
          : "right: 16px; left: auto;"}
    }

    .login-footer-bar {
      bottom: 16px;
      left: 12px;
      right: 12px;
    }

    .login-copyright {
      font-size: 13px;
      white-space: normal;
    }

    .sign-in {
      padding: 2rem !important;
    }

    .main-box {
      width: 100% !important;
      padding: 0.5rem !important;
    }

    .sidebox-img {
      display: none !important;
    }
  }

  /* Small phones */
  @media (max-width: 400px) {
    .form-section {
      padding: 12px 8px 72px;
    }

    .login-card {
      padding: 8px;
    }

    .login-heading h1 {
      font-size: 18px;
    }

    .login-heading .login-subtitle {
      font-size: 13px;
    }
  }

  /* Short viewports — keep switcher visible, allow form scroll */
  @media (max-height: 700px) {
    .form-section {
      justify-content: flex-start;
      padding-top: 16px;
      padding-bottom: 72px;
      overflow-y: auto;
    }

    .login-page {
      overflow: hidden;
    }
  }
`;
